import { UserLoan } from '@matech/thebigpos-sdk'

import { concatStrings } from '../../../../services/helpers'
import { getBorrowerUserFromLoanList } from './getBorrowerAndCoBorrowerFromLoanList'

const formatBorrowerName = (userLoans: UserLoan[]) => {
	const borrower = getBorrowerUserFromLoanList(userLoans)
	return concatStrings(
		borrower?.firstName,
		borrower?.lastName
	).getValue()
}

export default formatBorrowerName
